$(document).ready(function () {
  $("#ReviewScroll").click((e) => {
    e.stopPropagation();
    var el = document.getElementById("judgeme_product_reviews");
    var pos = el.getBoundingClientRect().top - 140;

    window.scrollBy({
    top: pos,
    behavior: 'smooth'
  });
  });

  var isTest =
    sections.instances[0].variants.product.title == "Petite Grande Topper";
  var options = sections.instances[0].variants.product.options;
  var colorIdx = options.indexOf("Color") + 1;
  var colorOptionName = "option" + colorIdx;
  var lengthIdx = options.indexOf("Length") + 1;
  var lengthOptionName = "option" + lengthIdx;
  var otherIdx = [1, 2, 3].filter(
    (item) => ![colorIdx, lengthIdx].includes(item)
  )[0];
  var otherOptionName = "option" + otherIdx;

  if (sections.instances.length > 0) {
    var currentVariant = sections.instances[0].variants?.currentVariant;
    if (currentVariant[colorOptionName])
      showLengthImage(
        currentVariant[colorOptionName],
        currentVariant[otherOptionName]
      );
    //console.log(sections.instances[0].variants)
  }

  /*属性选择窗口*/
  // console.log(theme.breakpoints.medium)
  if (window.innerWidth > theme.breakpoints.medium) {
    var prodImgModal = document.getElementById("productImgModal");

    var prod_img = document.getElementById("product_img");
    // Get the <span> element that closes the modal
    var span = document.getElementById("closeImageModal");
    // When the user clicks on <span> (x), close the modal

    if (typeof span != "undefined" && span != null) {
      span.onclick = function () {
        prodImgModal.style.display = "none";
        prod_video.src = "";
        document.body.classList.remove("modal-open");
      };
    }

    var prod_video = document.getElementById("ProductVideo");
    var right_images = document.getElementById("right-images");

    // When the user clicks the button, open the modal
    var prodImages = document.querySelectorAll(
      ".product-image-list .feature-row__image"
    );

    var imgs = [];
    var currentImg = "";
    prodImages.forEach((e) => {
      e.addEventListener("click", function (e) {
        e.preventDefault();
        var video = this.getAttribute("data-video");
        if (video) {
          prod_img.style.display = "none";
          prod_video.style.display = "unset";
          prod_video.src = video;
          //prod_video.load()
        } else {
          prod_video.style.display = "none";
          prod_img.style.display = "unset";
          var src = this.src;
          prod_img.src = src;
          prod_img.srcset = "";
          currentImg = src;
          resetZoom();
        }
        prodImgModal.style.display = "block";
        document.body.classList.add("modal-open");
      });
      var img = document.createElement("img");
      img.src = e.src;
      imgs.push(e.src);
      img.addEventListener("click", function (e) {
        e.preventDefault();
        var video = this.getAttribute("data-video");
        if (video) {
          prod_img.style.display = "none";
          prod_video.style.display = "unset";
          prod_video.src = video;
          //prod_video.load()
        } else {
          prod_video.style.display = "none";
          prod_img.style.display = "unset";
          var src = this.src;
          prod_img.src = src;
          prod_img.srcset = "";
          currentImg = src;
          resetZoom();
        }
      });
      right_images.appendChild(img);
    });

    var leftButton = document.getElementById("imageLeftButton");
    var rightButton = document.getElementById("imageRightButton");

    if (typeof template_2024 !== "undefined") {
      leftButton.addEventListener("click", function (e) {
        showNextImage(false);
      });
      rightButton.addEventListener("click", function (e) {
        showNextImage(true);
      });
    } else {
      leftButton.style.display = "none";
      rightButton.style.display = "none";
      $(".left-controls").hide();

      /** old template */
      var oldProdImages = document.querySelectorAll(
        ".product-single__thumbnail-image"
      );
      if (oldProdImages) {
        oldProdImages.forEach((e) => {
          e.addEventListener("click", function (e) {
            e.preventDefault();
            var video = this.getAttribute("data-video");
            if (video) {
              prod_img.style.display = "none";
              prod_video.style.display = "unset";
              prod_video.src = video;
              //prod_video.load()
            } else {
              prod_video.style.display = "none";
              prod_img.style.display = "unset";
              var src = this.src;
              prod_img.src = src;
              prod_img.srcset = "";
            }
            prodImgModal.style.display = "block";
            document.body.classList.add("modal-open");
          });
        });
      }

      var prod_main_img = document.querySelector(".product-featured-media");

      if (prod_main_img) {
        prod_main_img.addEventListener("click", function (e) {
          e.preventDefault();

          prod_img.src = "";
          var src = this.srcset;
          prod_img.srcset = src;

          prodImgModal.style.display = "block";
          document.body.classList.add("modal-open");
        });
      }

      /* end old template */
    }

    function showNextImage(isNext = true) {
      var idx = imgs.findIndex((x) => x == currentImg);
      if (isNext) {
        if (idx == imgs.length - 1) idx = 0;
        else idx += 1;
      } else {
        if (idx == 0) idx = imgs.length - 1;
        else idx -= 1;
      }
      prod_img.src = imgs[idx];
      currentImg = imgs[idx];
      resetZoom();
    }

    var zoomInButton = document.getElementById("ZoomInButton");
    var zoomOutButton = document.getElementById("ZoomOutButton");
    var zoomViewer = document.getElementById("zoomViewer");
    var zoomValue = document.getElementById("ZoomValue");
    var currentZoom = 1;
    var imageContainer = document.getElementById("ProductImageContainer");

    zoomInButton.addEventListener("click", function (e) {
      if (currentZoom == 6) return;
      currentZoom++;
      zoomValue.innerText = `${(currentZoom - 1) * 20}%`;
      zoomViewer.style = `transform: scale(${currentZoom}) translate(0px, 0px);`;
    });
    zoomOutButton.addEventListener("click", function (e) {
      if (currentZoom == 1) return;
      currentZoom--;
      zoomValue.innerText = `${(currentZoom - 1) * 20}%`;
      zoomViewer.style = `transform: scale(${currentZoom}) translate(0px, 0px);`;
    });

    function resetZoom() {
      zoomViewer.style = ``;
      currentZoom = 1;
      zoomValue.innerText = `0%`;
    }
    //zoomViewer.addEventListener("dragstart", dragstartHandler);

    var isMoving = false;
    var offsetX = 0;
    var offsetY = 0;
    function moveImage(event) {
      if (!isMoving) return;
      zoomViewer.style.left = event.clientX - offsetX + "px"; // 根据当前鼠标位置更新图片的水平位置
      zoomViewer.style.top = event.clientY - offsetY + "px"; // 根据当前鼠标位置更新图片的垂直位置

      if (event.type === "mouseup") {
        isMoving = false;
        zoomViewer.removeEventListener("mousemove", moveImage); // 松开鼠标后停止移动
      }
    }
    function dragImage(event) {
      event.preventDefault(); // 阻止默认事件发生（比如选中文本）
      if (currentZoom == 1) return;
      isMoving = true;
      offsetX = event.clientX - zoomViewer.offsetLeft; // 计算鼠标点击时与图片左边界之间的距离
      offsetY = event.clientY - zoomViewer.offsetTop; // 计算鼠标点击时与图片上边界之间的距离

      zoomViewer.addEventListener("mousemove", moveImage); // 添加鼠标移动事件监听器
    }

    zoomViewer.addEventListener("mousedown", dragImage); // 添加鼠标按下事件监听器
    zoomViewer.addEventListener("mouseup", function (e) {
      isMoving = false;
      zoomViewer.removeEventListener("mousemove", moveImage); // 松开鼠标后停止移动
    }); // 添加鼠标松开事件监听器
  } else {
    $(".defaultImg").click();
  }

  $("#ShowGroupTitle").on("change", function (e) {
    $(".swatch-color-group-title").each(function (idx, el) {
      if (e.target.checked) $(el).show();
      else $(el).hide();
    });
  });
  $("#ShowColorName").on("change", function (e) {
    $(".swatch-text").each(function (idx, el) {
      if (e.target.checked) $(el).show();
      else $(el).hide();
    });
    $(".variant__button-label").each(function (idx, el) {
      $(el).toggleClass("variant__color-swatch-no-text");
    });
  });
  $("#Show7Imgs").on("change", function (e) {
    $(".variant__button-label").each(function (idx, el) {
      if ($(el).data("img").endsWith("-cv")) {
        if (e.target.checked) $(el).show();
        else $(el).hide();
      }
    });
  });

  //商品属性选择选择
  var optionNames = document.querySelectorAll(".option-name");
  if (optionNames) {
    optionNames.forEach((e) => {
      e.addEventListener("click", function (e) {
        e.preventDefault();

        var optionName = this.getAttribute("option-name");
        var modalId = "option-" + optionName + "-modal";
        var modal = document.getElementById(modalId);
        modal.classList.add("modal-open");
        document.body.classList.add("modal-open");
      });
    });

    var swatchModals = document.querySelectorAll(".swatch-modal");

    if (swatchModals) {
      swatchModals.forEach((e) => {
        document.body.appendChild(e);
      });
    }

    var optionSelector = document.querySelectorAll(".single-option-selector");
    optionSelector.forEach((e) => {
      e.addEventListener("click", function (e) {
        var optionName = this.getAttribute("name");
        if (optionName == "properties[Size]") optionName = "Size";
        var modalId = "option-" + optionName + "-modal";
        var valueName = this.getAttribute("value-name");
        closeModal(modalId, this.getAttribute("value"), optionName, valueName);
        //Set length image
        var color = this.value;
        var currentVariant = sections.instances[0].variants?.currentVariant;

        if (optionName == "Color") {
          showLengthImage(color, currentVariant[otherOptionName]);
        } else if (optionName != "Length") {
          console.log(this.value);
          //showPrice()
        }
      });
    });

    var modalCloseButtons = document.querySelectorAll(".closeSwatchModal");
    if (modalCloseButtons) {
      modalCloseButtons.forEach((el) => {
        el.addEventListener("click", function (e) {
          var id = el.getAttribute("modal-id");
          closeModal(id);
        });
      });
    }
  }
  //show the length images based on the selected color
  function showLengthImage(color, size) {
    if (!color) return;
    $(".Length-input-wrap label").each(function (idx, el) {
      var lengthName = el.getAttribute("data-value-name").trim();
      var length = el.getAttribute("data-value").trim();

      var hasMetaImage = el.getAttribute("data-has-image");
      //如果在metafields设置了图像, 不更改背景图片
      if (!hasMetaImage) {
        var prefix = el.getAttribute("data-prefix") || "";
        var idx = el.style.backgroundImage.lastIndexOf("/");
        el.style.backgroundImage =
          el.style.backgroundImage.substring(0, idx) +
          `/${prefix}${color.replace(" ", "-").toLowerCase()}-${
            length.split(" ")[0]
          }.jpg`;
      }

      showPrice(el, color, length, size);
      /*
      var variant = sections.instances[0].variants.product.variants.find(
        (x) =>
          x["option" + colorIdx] == color &&
          x["option" + lengthIdx] == length &&
          (options.length == 2 ||
            (size && options.length == 3 && x["option" + lengthIdx] == size))
      );

      lengthName = lengthName || length;

      var text = variant
        ? `${lengthName.replace("/", "<br>")}<br> ${theme.Currency.formatMoney(
            variant?.price,
            theme.moneyFormat
          )} `
        : `${lengthName.replace("/", "<br>")}`;
      $(el).find("span").html(text);
      */
    });
  }

  function showPrice(el, color, length, size) {
    var lengthName = el.getAttribute("data-value-name").trim();
    length = length || el.getAttribute("data-value").trim();

    var sizeName = baseSizeJSON[size] || size;
    if (sizeName) {
      lengthName = lengthJSON[length + sizeName] || lengthName;
    }

    var variant = sections.instances[0].variants.product.variants.find(
      (x) =>
        x["option" + colorIdx] == color &&
        x["option" + lengthIdx] == length &&
        (!size || (size && x["option" + otherIdx] == size))
    );

    lengthName = lengthName || length;
    var text = variant
      ? `${lengthName.replace("/", "<br>")}<br> ${theme.Currency.formatMoney(
          variant?.price,
          theme.moneyFormat
        )} `
      : `${lengthName.replace("/", "<br>")}`;

    $(el).find("span").html(text);
  }

  //更改select 的option名称
  var colorJson = document.getElementById("ColorsJson");
  // console.log(colorJson)

  /*属性窗口结束*/

  //product builder

  var defaultColor = "";

  if (colorJson) {
    var colorMetiafields = JSON.parse(colorJson.innerHTML);

    var colorSelects = document.querySelectorAll(
      'select[data-option-name="Color"]'
    );
    if (colorSelects) {
      colorSelects.forEach((s) => {
        s.options.forEach((o) => {
          o.innerText = colorMetiafields[o.value];
        });
      });
    }
    /*
//Product builder
    var productBuilderEl = document.getElementById("product-builder");

    if (productBuilderEl && typeof colors !== "undefined") {
      addColorBuilder();
    }
    */
  }
  function closeModal(id, value, option, valueName) {
    var modal = document.getElementById(id);
    if (modal) {
      modal.classList.remove("modal-open");
      document.body.classList.remove("modal-open");
      if (option == "Size") {
        var el = document.getElementById("Variant" + option + "Input");
        el.value = value;
      } else {
        var label = document.getElementById("Variant" + option + "Label");
        if (label) {
          if (option == "Length" && !valueName) {
            var currentVariant = sections.instances[0].variants?.currentVariant;
            var sizeName =
              baseSizeJSON[currentVariant[otherOptionName]] ||
              currentVariant[otherOptionName];
            if (sizeName) {
              valueName = lengthJSON[value + sizeName] || valueName;
            }
          }

          if (valueName) {
            if (option == "Length") label.textContent = valueName;
            else label.textContent = valueName + " - " + value;
          } else if (value) {
            label.textContent = value;
          }
          //设置颜色的小图片
          if (option == "Color") {
            var img = document.getElementById("Variant" + option + "Image");
            var src = img.getAttribute("src");
            var idx = src.lastIndexOf("/");
            if (value.indexOf("/") > 0)
              value = value.toLowerCase().replace("/", "-");
            img.setAttribute(
              "src",
              src.substr(0, idx + 1) +
                value.replace(" ", "-").toLowerCase() +
                "_30x.jpg"
            );
          }
        }
      }
    }
  }

  /* Product builder */
  function addColorBuilder(isComparison) {
    var colorTitleDiv = document.createElement("div");
    colorTitleDiv.classList.add("product-builder-color-title");

    var colorDropdownEl = document.createElement("select");
    //colorDropdownEl.setAttribute('id','')
    var colorImageDiv = document.createElement("div");
    colorImageDiv.classList.add("product-builder-color");
    colorImageDiv.classList.add("row");
    colorImageDiv.classList.add("row-cols-4");
    colorImageDiv.classList.add("row-cols-xs-2");
    colorTitleDiv.append(colorDropdownEl);

    var btn = document.createElement("button");
    btn.classList = "btn product-form__cart-submit";
    btn.innerText = "Add comparison";
    colorTitleDiv.append(btn);
    btn.addEventListener("click", function () {
      addColorBuilder(true);
    });
    colorTitleDiv.append(btn);

    if (isComparison) {
      btn = document.createElement("button");
      btn.classList = "btn remove-btn";
      btn.innerText = "X";
      colorTitleDiv.append(btn);
      btn.addEventListener("click", function () {
        colorTitleDiv.remove();
        colorImageDiv.remove();
        lengthDiv.remove();
      });
      colorTitleDiv.append(btn);
    }

    productBuilderEl.append(colorTitleDiv);
    productBuilderEl.append(colorImageDiv);

    var lengthDiv = document.createElement("div");
    lengthDiv.classList.add("product-builder-length");
    lengthDiv.classList.add("row");
    lengthDiv.classList.add("row-cols-4");
    lengthDiv.classList.add("row-cols-xs-2");

    productBuilderEl.appendChild(lengthDiv);

    colors.forEach((key) => {
      if (!defaultColor) defaultColor = key;
      var opt = document.createElement("option");
      opt.text = `${colorMetiafields[key]}-${key}`;
      opt.value = key;
      colorDropdownEl.add(opt);
    });

    colorDropdownEl.addEventListener("change", function (e) {
      showImages(e.target.value, colorImageDiv, lengthDiv);
    });
    showImages(defaultColor, colorImageDiv, lengthDiv);
  }
  //show images when the color dropdown changed.
  function showImages(color, colorImageDiv, lengthDiv) {
    colorImageDiv.textContent = "";
    var imgs = ["front", "left", "right", "back"];
    imgs.forEach((k) => {
      var d = document.createElement("div");
      d.classList.add("col");

      var img = document.createElement("img");
      img.src = `https://cdn.shopifycdn.net/s/files/1/0253/8317/4195/files/${color}-${k}.jpg`;
      img.loading = "lazy";
      d.append(img);
      colorImageDiv.append(d);
    });
    showLengths(lengths, color, lengthDiv);
  }

  function showLengths(lengths, color, lengthDiv) {
    if (!lengths) return;
    lengthDiv.textContent = "";
    lengths.forEach((l) => {
      var ld = document.createElement("div");
      ld.classList.add("length-list");
      ld.classList.add("col");
      var img = document.createElement("img");
      img.src = `https://cdn.shopify.com/s/files/1/0253/8317/4195/files/${color}-${l.substring(
        0,
        2
      )}.jpg`;
      img.loading = "lazy";
      ld.appendChild(img);

      var variant = sections.instances[0].variants.product.variants.find(
        (x) => x.option1 == color && x.option2 == l
      );

      var s = document.createElement("span");
      s.innerText = `${l} - ${theme.Currency.formatMoney(
        variant?.price,
        theme.moneyFormat
      )} `;
      ld.appendChild(s);

      lengthDiv.appendChild(ld);
    });
  }
  /* End product builder */

  /*accordion */
  var collContents = document.getElementsByClassName("accordion-content");
  var coll = document.getElementsByClassName("accordion");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
      // this.classList.toggle("active");
      var n = 0;
      if (this.classList.contains("active")) {
        for (n = 0; n < coll.length; n++) {
          coll[n].classList.remove("active");
        }
      } else {
        for (n = 0; n < coll.length; n++) {
          coll[n].classList.remove("active");
        }

        this.classList.toggle("active");
      }
    });
  }

  
});

 
